/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, IconButton, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PhoneInput from 'react-phone-input-2';

const DinamicInputs = ({
  values,
  onChange,
  loading,
  error,
  helperText,
  name,
  inputType = 'text',
  ...props
}) => {
  const maxInputAbility = 10;

  const [inputCount, setInputCount] = useState(1);

  const [inputValues, setInputValues] = useState([]);

  const incrementInputCount = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, null]);
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (values) {
      const currentAvalCount = values.length;
      setInputCount(currentAvalCount);
      setInputValues(values);
    }
  }, [values]);
  console.log(inputType, 'ddfdsf');
  return (
    <Box
      fullWidth
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      {Array(inputCount)
        .fill('')
        .map((input, index) => (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                width: '100%'
              }}
              key={`box-${index}`}
            >
              {inputType === 'phone' ? (
                <div style={{ position: 'relative', width: '100%' }}>
                  <PhoneInput
                    defaultCountry="AR"
                    {...props}
                    value={inputValues[index] ?? ''}
                    onChange={value => {
                      const updateValues = [...inputValues];
                      updateValues[index] = value ?? null;
                      onChange(updateValues);
                    }}
                    inputStyle={{
                      width: '100%',
                      paddingRight: '40px',
                      marginBottom: '1rem',
                      marginTop: '1rem'
                    }}
                    containerStyle={{
                      width: '100%'
                    }}
                  />
                  <IconButton
                    key={`button-${index}`}
                    aria-label="delete"
                    onClick={() => {
                      const updatedAvals = inputValues.filter(
                        (_, i) => i !== index
                      );
                      onChange(updatedAvals);
                      setInputCount(inputCount - 1);
                    }}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 2
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ) : (
                <TextField
                  {...props}
                  key={`input-${index}`}
                  options={inputValues}
                  id="dinamicInput"
                  name={name}
                  value={inputValues[index] ?? null}
                  loading={loading}
                  disabled={loading}
                  fullWidth
                  onChange={e => {
                    const updateValues = [...inputValues];
                    updateValues[index] = e.target.value ?? null;
                    onChange(updateValues);
                  }}
                  FormHelperTextProps={{
                    sx: {
                      margin: 0
                    }
                  }}
                  error={error[index]}
                  helperText={helperText[index]}
                  sx={{ 
                    marginBottom: 2, 
                    marginTop: 2,
                    width: '100%'
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        key={`button-${index}`}
                        aria-label="delete"
                        onClick={() => {
                          const updatedAvals = inputValues.filter(
                            (_, i) => i !== index
                          );
                          onChange(updatedAvals);
                          setInputCount(inputCount - 1);
                        }}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )
                  }}
                />
              )}
            </Box>
          </>
        ))}
      <Box
        key="addButton"
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Button
          type="button"
          key="addButton"
          color="primary"
          variant="text"
          disabled={inputCount >= maxInputAbility}
          onClick={incrementInputCount}
          startIcon={<AddIcon />}
        >
          {t('COMMON.ADD')}
        </Button>
      </Box>
    </Box>
  );
};
DinamicInputs.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  name: PropTypes.string,
  inputType: PropTypes.string
};

export default DinamicInputs;
